(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerAssignFolder',
	};

    $(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

    form.success = function success(response)
	{
        if (!Adzuki.Form.hasError(response)) {
            $('.modal').modal('hide');
           document.location = Adzuki.base_uri + '/LivePlanner/library';
        }

        return false;
    };
}(jQuery, window.Adzuki || {}));